import React from 'react'
import {Icon} from '@chakra-ui/react'

const MinusIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" data-testid="minus-icon" {...props}>
            <rect x="3.33496" y="18.5417" width="33.3333" height="3" fill="currentColor" />
        </Icon>
    )
}

export default MinusIcon
